import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e7be8b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-start break-word"
}, "TT", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word"
}, "Mã vật tư", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word"
}, "Tên vật tư", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word"
}, "Đơn vị", -1))
const _hoisted_5 = { class: "text-start break-word" }
const _hoisted_6 = { class: "break-word" }
const _hoisted_7 = { class: "break-word" }
const _hoisted_8 = { class: "text-center break-word" }
const _hoisted_9 = { class: "text-end break-word" }
const _hoisted_10 = { class: "text-end break-word" }
const _hoisted_11 = { class: "text-end break-word" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "break-word" }, "-", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "break-word" }, "-", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "break-word" }, "-", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["colspan"]

import { PropType } from "vue";
import { REPORT_COLUMN_WIDTHS } from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";
import {
  INhapKhoVatTuPhuTungRowResponseBase,
  INhapXuatTonKhoDonViMeta,
} from "@/core/interfaces/ApiResponses";
import {
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";


export default /*#__PURE__*/_defineComponent({
  __name: 'NhapKhoVatTuPhuTungTable',
  props: {
  isPrintModal: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  items: {
    type: Array as PropType<INhapKhoVatTuPhuTungRowResponseBase[]>,
    default: () => [],
  },
  donVi: {
    type: Array as PropType<INhapXuatTonKhoDonViMeta[]>,
    default: () => [],
  },
  stripe: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const colW = {
  stt: REPORT_COLUMN_WIDTHS.stt,
  ma: REPORT_COLUMN_WIDTHS.ma,
  ten: REPORT_COLUMN_WIDTHS.ten,
  dvt: REPORT_COLUMN_WIDTHS.dvt,
  donGia: REPORT_COLUMN_WIDTHS.donGia,
  soLuong: REPORT_COLUMN_WIDTHS.soLuong,
  thanhTien: REPORT_COLUMN_WIDTHS.thanhTien,
};

const metricLabels = ["Số lượng", "Đơn giá", "Thành tiền"] as const;

const metricColWidth: Record<(typeof metricLabels)[number], keyof typeof colW> =
  {
    "Số lượng": "soLuong",
    "Đơn giá": "donGia",
    "Thành tiền": "thanhTien",
  };

const formatQuantityValue = (value?: number) => {
  if (value === undefined || value === null) return "-";
  return formatQuantity(value);
};

const formatUnitPriceValue = (value?: number) => {
  if (value === undefined || value === null) return "-";
  return formatUnitPrice(value);
};

const formatAmountValue = (value?: number) => {
  if (value === undefined || value === null) return "-";
  return formatAmount(value);
};



const getDonViData = (
  item: INhapKhoVatTuPhuTungRowResponseBase,
  donViId: number
) => {
  return item[`DV_${donViId}`] ?? null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    style: { width: '100%', fontSize: '0.8rem' },
    class: _normalizeClass({
      'table-striped': __props.stripe,
      'bao-cao-table--print': __props.isPrintModal,
    })
  }, [
    _createElementVNode("colgroup", null, [
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.stt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ma}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ten}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dvt}px` })
      }, null, 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.donVi, (unit) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: `${unit.id}_cols`
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(metricLabels, (metric) => {
            return _createElementVNode("col", {
              key: `${unit.id}_${metric}`,
              style: _normalizeStyle({ width: `${colW[metricColWidth[metric]]}px` })
            }, null, 4)
          }), 64))
        ], 64))
      }), 128))
    ]),
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.donVi, (unit) => {
          return (_openBlock(), _createElementBlock("th", {
            key: unit.id,
            colspan: "3",
            class: "text-center break-word"
          }, _toDisplayString(unit.ten_don_vi), 1))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.donVi, (unit) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `${unit.id}_sub`
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(metricLabels, (label) => {
              return _createElementVNode("th", {
                key: `${unit.id}_${label}`,
                class: "text-center break-word"
              }, [
                _createElementVNode("div", null, _toDisplayString(label), 1)
              ])
            }), 64))
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (__props.items.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${item.tt}-${item.ma_vat_tu}`,
              class: _normalizeClass({
            'bao-cao-table-data-row': __props.isPrintModal,
            'bao-cao-table-data-row--last':
              __props.isPrintModal && index === __props.items.length - 1,
          })
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(item.tt), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(item.ma_vat_tu), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(item.ten_vat_tu), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(item.don_vi_tinh), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.donVi, (unit) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `${unit.id}_data`
                }, [
                  (getDonViData(item, unit.id))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", _hoisted_9, _toDisplayString(formatQuantityValue(getDonViData(item, unit.id)?.so_luong)), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(formatUnitPriceValue(getDonViData(item, unit.id)?.don_gia)), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(formatAmountValue(getDonViData(item, unit.id)?.thanh_tien)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14
                      ], 64))
                ], 64))
              }), 128))
            ], 2))
          }), 128))
        : (_openBlock(), _createElementBlock("tr", _hoisted_15, [
            _createElementVNode("td", {
              colspan: 4 + __props.donVi.length * 3,
              class: "text-center fst-italic py-4 break-word"
            }, " Không có dữ liệu ", 8, _hoisted_16)
          ]))
    ])
  ], 2))
}
}

})